export const getContainerMaxWidth = (containerWidth) => {
  const fullWidth = 'w-full'
  return (
    {
      small: 'laptop:max-w-[570px]',
      medium: 'laptop:max-w-[780px]',
      large: 'laptop:max-w-[820px]',
      full: fullWidth,
    }[containerWidth] ?? fullWidth
  )
}

export const getOffset = (offsetName) => {
  return (
    {
      topSmall: 'relative -top-[100]px] mt-[100px] -mb-[100px]',
      topBig: 'relative -top-[250px] mt-[350px] -mb-[250px]',
    }[offsetName] ?? ''
  )
}
